$bog_formigo_builder $mol_page
	template $bog_formigo_template
	title <= form_title \
	tools /
		<= Preview $mol_link
			arg *
				fill <= template_link
				template null
				submissions null
				submission null
				settings null
			sub /
				<= Preview_icon $mol_icon_eye
		<= Submissions_link $mol_link
			arg *
				submissions <= template_link \
				template null
				fill null
				submission null
				settings null
			sub /
				<= Submissions_icon $mol_icon_format_list_bulleted
		<= Publish $mol_check_icon
			checked? <=> published? false
			Icon <= Publish_icon $mol_icon_earth
	body /
		<= Title_field $mol_form_field
			name @ \Form Title
			Content <= Title_input $mol_string
				value? <=> form_title_edit? \
				hint @ \Enter form title...
		<= Description_field $mol_form_field
			name @ \Description
			Content <= Description_input $mol_textarea
				value? <=> description? \
				hint @ \Form description...
		<= Fields_label $mol_labeler
			title @ \Fields
			Content <= Fields $mol_list
				rows <= field_rows /
		<= Add_field $mol_button_major
			title @ \Add Field
			click? <=> add_field? null
	selected? null
	Field_row*0 $bog_formigo_builder_field
		field_index <= field_index* 0
		field_label <= field_label* \
		field_type <= field_type* \str
		field_required <= field_required* false
		field_select!index <=> field_select!index null
		field_remove!index <=> field_remove!index null
	Props $bog_formigo_builder_props
		field <= selected_field null
